import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Form, Label, Checkbox, Grid, Radio } from 'semantic-ui-react';

import * as cm_action from 'actions/commons';

const propTypes = {};

const defaultProps = {};

class Vitality extends Component {
  constructor(props) {
    super(props);

    let value = props.defaultValue < 0 ? 1 : props.defaultValue;

    this.state = {
      value: props.defaultValue ? props.defaultValue : 1
    };
  }
  handleChange = async (e, { value }) => {
    try {
      const { cmAPI } = this.props;
      cmAPI.vitalityChange({
        type: 'vitality',
        name: 'value',
        value: value
      });

      await this.setState({
        value: value
      });
    } catch (e) {
      console.log('###### e : ', e);
    } finally {
    }
  };
  render() {
    const { defaultValue, isLabel, label } = this.props;
    const { value } = this.state;

    return (
      <Form.Group inline className="field">
        {isLabel ? <label style={label}>사용자 상태</label> : null}
        <Form.Field
          control={Radio}
          label="활성 사용자"
          value={defaultValue < 0 ? 1 : defaultValue ? defaultValue : 1}
          checked={value > 0}
          onChange={this.handleChange}
        />
        <Form.Field
          style={{ marginLeft: 10 }}
          control={Radio}
          label="일시정지 사용자"
          value="-1"
          checked={value < 0}
          onChange={this.handleChange}
        />
      </Form.Group>
    );
  }
}

Vitality.propTypes = propTypes;
Vitality.defaultProps = defaultProps;

Vitality = connect(
  (state) => ({}),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        vitalityChange: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(Vitality);

export default Vitality;
